import Home from './component/Apps/Home'
import './App.css';

function App() {
  return (
    <div className="App">
     <Home/> 
    </div>
  );
}

export default App;
